module.exports = __webpack_public_path__ + "images/Roku-6886f0.png";